const STORE_CURRENCY = "EUR";

// 2.1 Registration event
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/account")) {
    if (e.target.querySelector('input[name="customer[first_name]"]')) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "sign_up",
        method: "email",
      });
    }
  }
});

// 2.2 Login event
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/account/login")) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "login",
      method: "email",
    });
  }
});

// 2.3 Search event
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/search")) {
    const searchInput = e.target.querySelector('input[name="q"]');
    if (searchInput) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "search",
        search_term: searchInput.value,
      });
    }
  }
});

// 2.4 Newsletter subscribe
document.addEventListener("submit", function (e) {
  if (
    e.target.querySelector('input[name="contact[email]"]') ||
    e.target.querySelector("[data-newsletter-form]")
  ) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "subscribe",
      method: "email",
    });
  }
});

// 2.5 Contact form
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/contact")) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "contact",
      method: "form",
    });
  }
});

// 2.6 Error - Recipient form
document.addEventListener("submit", function (e) {
  const recipientForm = e.target.closest("[data-recipient-form]");
  if (!recipientForm) return;

  setTimeout(function () {
    const errorMessage = recipientForm.querySelector(
      "[data-recipient-form-error-message]"
    );
    if (errorMessage && errorMessage.offsetHeight > 0) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "error",
        method: "form_validation",
        failed_event: "recipient_form",
      });
    }
  }, 500);
});

// 2.6 Error - Age gate form
document.addEventListener("submit", function (e) {
  const ageGateForm = e.target.closest("[data-age-gate]");
  if (!ageGateForm) return;

  setTimeout(function () {
    const errorMessage = ageGateForm.querySelector("[data-age-gate-error]");

    if (
      errorMessage &&
      errorMessage.style.display !== "none" &&
      errorMessage.offsetHeight > 0
    ) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "error",
        method: "form_validation",
        failed_event: "age_gate",
      });
    }
  }, 500);
});

// 2.6 Error - Contact forms (both types)
document.addEventListener("submit", function (e) {
  const contactForm =
    e.target.closest(".custom-contact-form") ||
    e.target.closest(".contact-form--contact-section");
  if (!contactForm) return;

  setTimeout(function () {
    const errorMessage =
      contactForm.querySelector(".custom-contact-form__errors") ||
      contactForm.querySelector(".contact-form__form-errors") ||
      contactForm.querySelector(".form__error");

    if (errorMessage && errorMessage.offsetHeight > 0) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "error",
        method: "form_validation",
        failed_event: "contact",
      });
    }
  }, 500);
});

// 2.7 Social networks clicks
document.addEventListener("click", function (e) {
  const link = e.target.closest("a");
  if (
    link &&
    (link.href.includes("facebook.com") ||
      link.href.includes("instagram.com") ||
      link.href.includes("twitter.com") ||
      link.href.includes("tiktok.com") ||
      link.href.includes("youtube.com"))
  ) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "social",
      method: "click",
    });
  }
});

// 2.8 Affiliate
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("/pages/become-an-affiliate")) {
    const loginBtn = document.querySelector(
      'a[href="https://af.uppromote.com/youthandearth/login"]'
    );
    const registerBtn = document.querySelector(
      'a[href="https://af.uppromote.com/youthandearth/register"]'
    );

    if (loginBtn) {
      loginBtn.addEventListener("click", function () {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "affiliate",
          method: "click",
          type: "login",
        });
      });
    }
    if (registerBtn) {
      registerBtn.addEventListener("click", function () {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "affiliate",
          method: "click",
          type: "sign_up",
        });
      });
    }
  }
});

// 2.9 Quiz - Submit and Skip with products
document.addEventListener("DOMContentLoaded", function () {
  const selectors = [
    "#lightbox-bde14eb0-7849-4f64-b8b7-0bd8f97b6401",
    '[id*="lightbox-"]',
    ".digioh_universal_smart_tag",
    'iframe[id*="lightbox-iframe"]',
  ];

  let quizContainer = null;

  selectors.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) {
      if (!quizContainer) quizContainer = element;
    }
  });

  if (!quizContainer) {
    setTimeout(() => {
      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element && !quizContainer) {
          quizContainer = element;
          setupQuizTracking(quizContainer);
        }
      });
    }, 2000);
    return;
  }

  setupQuizTracking(quizContainer);
});

function setupQuizTracking(container) {
  function setupButtonListeners() {
    const iframe = container.querySelector("iframe");
    if (iframe && iframe.contentDocument) {
      try {
        const skipButton = iframe.contentDocument.querySelector("#ep2button3");
        const submitButton =
          iframe.contentDocument.querySelector("#ep2button1");

        if (skipButton && !skipButton.hasQuizListener) {
          skipButton.addEventListener("click", handleQuizButtonClick);
          skipButton.hasQuizListener = true;
        }

        if (submitButton && !submitButton.hasQuizListener) {
          submitButton.addEventListener("click", handleQuizButtonClick);
          submitButton.hasQuizListener = true;
        }
      } catch (e) {}
    }
  }

  function handleQuizButtonClick() {
    function waitForProducts(maxAttempts = 20, attemptInterval = 500) {
      let attempts = 0;

      const checkForProducts = () => {
        attempts++;

        const iframe = container.querySelector("iframe");
        if (!iframe || !iframe.contentDocument) {
          if (attempts < maxAttempts) {
            setTimeout(checkForProducts, attemptInterval);
            return;
          }
          return;
        }

        try {
          const productCards =
            iframe.contentDocument.querySelectorAll(".product-card");

          const validCards = Array.from(productCards).filter((card) => {
            const image = card.querySelector(".product-card_image");
            const title = card.querySelector(".product-card_title");
            const priceElement = card.querySelector(
              ".product-card_price .currency"
            );
            const button = card.querySelector(".product-card_button");
            return image && title && priceElement && button;
          });

          if (validCards.length > 0) {
            collectAndSendProducts(iframe.contentDocument, validCards);
            return;
          }

          if (attempts < maxAttempts) {
            setTimeout(checkForProducts, attemptInterval);
          } else {
          }
        } catch (e) {
          if (attempts < maxAttempts) {
            setTimeout(checkForProducts, attemptInterval);
          }
        }
      };

      checkForProducts();
    }

    function collectAndSendProducts(iframeDocument, productCards) {
      const recommendedProducts = [];

      productCards.forEach((card, index) => {
        const image = card.querySelector(".product-card_image");
        const title = card.querySelector(".product-card_title");
        const priceElement = card.querySelector(
          ".product-card_price .currency"
        );
        const button = card.querySelector(".product-card_button");

        const price = parseFloat(
          priceElement.textContent.replace(/[^\d.]/g, "")
        );

        recommendedProducts.push({
          item_name: title.textContent.trim(),
          item_id: button.dataset.sku,
          price: price,
          currency:
            typeof STORE_CURRENCY !== "undefined" ? STORE_CURRENCY : "GBP",
          item_brand: "youth&earth",
          item_category: "Quiz Recommendation",
          item_list_name: "quiz_results",
          item_list_id: "Q1",
          index: (index + 1).toString(),
          quantity: 1,
          item_variant: image.dataset.variantId,
        });
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "quiz",
        ecommerce: {
          items: recommendedProducts,
        },
      });
    }

    waitForProducts();
  }

  const observer = new MutationObserver(function () {
    setTimeout(setupButtonListeners, 200);
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  setInterval(setupButtonListeners, 3000);
}

// 3.1 Category products - view_item_list
document.addEventListener("DOMContentLoaded", function () {
  function getPageInfo() {
    const url = window.location.pathname;

    if (url.includes("/collections/")) {
      return {
        listName: "category",
        listId: "C1",
        productSelector: ".product-wrap, .product-card",
        itemCategorySelector: ".collection__title",
      };
    } else if (url === "/") {
      return {
        listName: "homepage",
        listId: "H1",
        productSelector: ".product-wrap, .product-card",
        itemCategorySelector: ".section-heading-featured-collection",
      };
    } else if (url.includes("/search")) {
      return {
        listName: "search_results",
        listId: "S1",
        productSelector: ".search__item, .product-wrap, .product-card",
        itemCategory: "Search Results",
      };
    } else if (url.includes("/blog")) {
      return {
        listName: "blog_post",
        listId: "BP1",
        productSelector: ".product-wrap, .product-card",
        itemCategorySelector: ".section-heading-featured-collection",
      };
    } else if (url.includes("/blogs")) {
      return {
        listName: "blog",
        listId: "B1",
        productSelector: ".product-wrap, .product-card",
        itemCategorySelector: ".section-heading-featured-collection",
      };
    } else if (url.includes("/pages/longevity-tips")) {
      return {
        listName: "longevity_tips",
        listId: "LT1",
        productSelector: ".product-wrap, .product-card",
        itemCategorySelector: ".section-heading-featured-collection",
      };
    } else if (url.includes("/pages/sirtuins")) {
      return {
        listName: "sirtuins_page",
        listId: "SI1",
        productSelector: ".product-wrap, .product-card",
        itemCategory: "Recommended Sirtuin Products",
      };
    } else if (url.includes("/pages/our-mission")) {
      return {
        listName: "our_mission_page",
        listId: "OM1",
        productSelector: ".product-wrap, .product-card",
        itemCategory: "Providing Personal Longevity",
      };
    } else if (url.includes("/pages/nad")) {
      return {
        listName: "nad_page",
        listId: "N1",
        productSelector: ".product-wrap, .product-card",
        itemCategory: "Shop our Range of NAD+ Products",
      };
    }
    return null;
  }

  const pageInfo = getPageInfo();
  if (!pageInfo) return;

  function getCleanProductName(titleElement) {
    const firstTextNode = titleElement.childNodes[0];
    if (firstTextNode && firstTextNode.nodeType === Node.TEXT_NODE) {
      return firstTextNode.textContent.trim();
    }

    const clone = titleElement.cloneNode(true);
    clone.querySelectorAll("div, span, p, small").forEach((el) => el.remove());
    return clone.textContent.trim();
  }

  const observedProducts = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      const visibleProducts = [];

      entries.forEach((entry) => {
        if (entry.isIntersecting && !observedProducts.has(entry.target)) {
          observedProducts.add(entry.target);

          const product = entry.target;
          let titleElement, priceElement, productName, price, productSku;

          let itemCategory;
          if (pageInfo.itemCategory) {
            itemCategory = pageInfo.itemCategory.replace(/\n/g, " ").trim();
          } else if (pageInfo.itemCategorySelector) {
            const categoryElement = document.querySelector(
              pageInfo.itemCategorySelector
            );
            itemCategory = categoryElement
              ? categoryElement.textContent
                  .replace(/\n/g, " ")
                  .replace(/\s{2,}/g, " ")
                  .trim()
              : "Product List";
          } else {
            itemCategory = "Product List";
          }

          if (product.classList.contains("amp-cart__cart-line")) {
            titleElement = product.querySelector(".amp-cart__cart-line-title");
            priceElement = product.querySelector(
              ".amp-cart__cart-line-price__no-discount"
            );
            productSku = product.dataset.productSku || product.dataset.sku;
          } else {
            titleElement = product.querySelector(
              ".product-thumbnail__title, .product-title, .product-name, .search-result__title--product a"
            );
            priceElement = product.querySelector(
              ".price, .product-price, .currency, .money"
            );
            productSku =
              product.dataset.productSku ||
              product.dataset.sku ||
              product.querySelector("[data-product-sku]")?.dataset.productSku ||
              product.querySelector("[data-sku]")?.dataset.sku;
          }

          if (titleElement && priceElement && productSku) {
            if (pageInfo.listName === "search_results") {
              productName = titleElement.textContent
                .replace(/\n/g, " ")
                .replace(/\s+/g, " ")
                .replace(/Select a size/gi, "")
                .trim();
            } else {
              productName = getCleanProductName(titleElement);
            }

            price = parseFloat(
              priceElement.textContent
                .replace(/[^\d.,]/g, "")
                .replace(/,/g, ".")
            );

            if (productName && price && productSku) {
              visibleProducts.push({
                item_name: productName,
                item_id: productSku,
                price: price,
                currency: STORE_CURRENCY,
                item_brand: "youth&earth",
                item_category: itemCategory,
                item_list_name: pageInfo.listName,
                item_list_id: pageInfo.listId,
                index: (
                  Array.from(observedProducts).indexOf(product) + 1
                ).toString(),
                quantity: 1,
              });
            }
          }
        }
      });

      if (visibleProducts.length > 0) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            items: visibleProducts,
          },
        });
      }
    },
    { threshold: 1.0 }
  );

  const products = document.querySelectorAll(
    `${pageInfo.productSelector}, .amp-cart__cart-line`
  );
  products.forEach((product) => observer.observe(product));

  // Observe new products in DOM
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const newProducts = node.matches?.(
              ".product-card, .product-wrap, .search__item"
            )
              ? [node]
              : node.querySelectorAll?.(
                  ".product-card, .product-wrap, .search__item"
                ) || [];

            newProducts.forEach((product) => {
              if (!observedProducts.has(product)) {
                observer.observe(product);
              }
            });
          }
        });
      }
    });
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// 3.1 Category Quiz products
document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("/pages/quiz")) {
    return;
  }

  let observedProducts = new Set();
  let visibleProducts = [];
  let intersectionObserver = null;
  let lastSentCount = 0;

  const quizSelectors = [
    "#lightbox-bde14eb0-7849-4f64-b8b7-0bd8f97b6401",
    '[id*="lightbox-"]',
    ".digioh_universal_smart_tag",
    'iframe[id*="lightbox-iframe"]',
  ];

  const pageInfo = {
    listName: "quiz_recommendations",
    listId: "Q1",
  };

  function getProductData(productElement) {
    try {
      const image = productElement.querySelector(".product-card_image");
      const title = productElement.querySelector(".product-card_title");
      const priceElement = productElement.querySelector(
        ".product-card_price .currency"
      );
      const button = productElement.querySelector(".product-card_button");

      if (image && title && priceElement && button) {
        const price = parseFloat(
          priceElement.textContent.replace(/[^\d.]/g, "")
        );

        return {
          productName: title.textContent.trim(),
          productSku: button.dataset.sku,
          price: price,
          itemCategory: "Quiz Recommendation",
          variantId: image.dataset.variantId,
          isValid: true,
        };
      }

      return { isValid: false };
    } catch (e) {
      return { isValid: false };
    }
  }

  function sendViewItemListEvent() {
    if (visibleProducts.length > lastSentCount) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          items: visibleProducts,
        },
      });
      lastSentCount = visibleProducts.length;
    }
  }

  function handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !observedProducts.has(entry.target)) {
        observedProducts.add(entry.target);

        const productData = getProductData(entry.target);

        if (productData.isValid) {
          const productInfo = {
            item_name: productData.productName,
            item_id: productData.productSku,
            price: productData.price,
            currency:
              typeof STORE_CURRENCY !== "undefined" ? STORE_CURRENCY : "GBP",
            item_brand: "youth&earth",
            item_category: productData.itemCategory,
            item_list_name: pageInfo.listName,
            item_list_id: pageInfo.listId,
            index: (
              Array.from(observedProducts).indexOf(entry.target) + 1
            ).toString(),
            quantity: 1,
            item_variant: productData.variantId,
          };

          visibleProducts.push(productInfo);
        }
      }
    });

    setTimeout(sendViewItemListEvent, 100);
  }

  function setupProductObserver(container) {
    const iframe = container.querySelector("iframe");
    if (!iframe || !iframe.contentDocument) return;

    try {
      if (intersectionObserver) {
        intersectionObserver.disconnect();
      }

      intersectionObserver = new IntersectionObserver(handleIntersection, {
        root: iframe.contentDocument,
        rootMargin: "50px",
        threshold: 0.5,
      });

      const productCards =
        iframe.contentDocument.querySelectorAll(".product-card");

      productCards.forEach((card) => {
        intersectionObserver.observe(card);
      });
    } catch (e) {}
  }

  function findQuizContainer() {
    let quizContainer = null;

    quizSelectors.forEach((selector) => {
      const element = document.querySelector(selector);
      if (element && !quizContainer) {
        quizContainer = element;
      }
    });

    return quizContainer;
  }

  function initQuizProductTracking() {
    const container = findQuizContainer();

    if (!container) {
      return;
    }

    const containerObserver = new MutationObserver(function () {
      setTimeout(() => setupProductObserver(container), 500);
    });

    containerObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    setInterval(() => setupProductObserver(container), 3000);
  }

  setTimeout(initQuizProductTracking, 1000);

  setTimeout(() => {
    if (!findQuizContainer()) {
      initQuizProductTracking();
    }
  }, 5000);
});

// 3.2 Cart drawer products
// No SKU for products in cart drawer via APP
document.addEventListener("DOMContentLoaded", function () {
  const observedCartItems = new Set();
  const cartObserver = new IntersectionObserver(
    (entries) => {
      const visibleCartItems = [];

      entries.forEach((entry) => {
        if (entry.isIntersecting && !observedCartItems.has(entry.target)) {
          observedCartItems.add(entry.target);

          const product = entry.target;

          const titleElement = product.querySelector(
            ".amp-cart__cart-line-title"
          );
          const priceElement = product.querySelector(
            ".amp-cart__cart-line-price__no-discount, .amp-cart__cart-line-price"
          );
          const quantityInput = product.querySelector(
            ".amp-cart__line-quantity-selector-input"
          );

          let productSku = product.dataset.productSku || product.dataset.sku;

          if (!productSku) {
            const upgradeBtn = product.querySelector(
              ".amp-cart__cart-line-upgrade-to-subscription-button"
            );
            if (upgradeBtn) {
              const ariaLabel = upgradeBtn.getAttribute("aria-label");
              if (ariaLabel) {
                productSku = ariaLabel.replace("update", "").trim();
              }
            }
          }

          if (titleElement && priceElement) {
            const productName = titleElement.textContent.trim();
            const price = parseFloat(
              priceElement.textContent
                .replace(/[^\d.,]/g, "")
                .replace(/,/g, ".")
            );
            const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

            if (productName && !isNaN(price)) {
              visibleCartItems.push({
                item_name: productName,
                item_id: productSku || "unknown",
                price: price,
                currency:
                  typeof STORE_CURRENCY !== "undefined"
                    ? STORE_CURRENCY
                    : "EUR",
                item_brand: "youth&earth",
                item_category: "Cart Drawer",
                item_list_name: "cart_drawer",
                item_list_id: "CD1",
                index: (
                  Array.from(observedCartItems).indexOf(product) + 1
                ).toString(),
                quantity: quantity,
              });
            }
          }
        }
      });

      if (visibleCartItems.length > 0) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            items: visibleCartItems,
          },
        });
      }
    },
    { threshold: 0.5 }
  );

  const cartMutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const newCartLines = node.matches?.(".amp-cart__cart-line")
              ? [node]
              : node.querySelectorAll?.(".amp-cart__cart-line") || [];

            newCartLines.forEach((line) => {
              if (!observedCartItems.has(line)) {
                cartObserver.observe(line);
              }
            });

            if (
              node.querySelector &&
              node.querySelector(".amp-cart-drawer__inner")
            ) {
              const existingLines = node.querySelectorAll(
                ".amp-cart__cart-line"
              );
              existingLines.forEach((line) => {
                if (!observedCartItems.has(line)) {
                  cartObserver.observe(line);
                }
              });
            }
          }
        });
      }
    });
  });

  cartMutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// 3.3 Cart quantity decrease tracking
document.addEventListener("DOMContentLoaded", function () {
  function getCartItemData(cartLine) {
    try {
      const titleElement = cartLine.querySelector(".amp-cart__cart-line-title");
      const priceElement = cartLine.querySelector(
        ".amp-cart__cart-line-price__no-discount, .amp-cart__cart-line-price"
      );

      let productSku = cartLine.dataset.productSku || cartLine.dataset.sku;

      if (!productSku) {
        const upgradeBtn = cartLine.querySelector(
          ".amp-cart__cart-line-upgrade-to-subscription-button"
        );
        if (upgradeBtn) {
          const ariaLabel = upgradeBtn.getAttribute("aria-label");
          if (ariaLabel) {
            productSku = ariaLabel.replace("update", "").trim();
          }
        }
      }

      if (titleElement && priceElement) {
        const itemName = titleElement.textContent.trim();
        const price = parseFloat(
          priceElement.textContent.replace(/[^\d.,]/g, "").replace(/,/g, ".")
        );

        return {
          itemName,
          itemId: productSku || "unknown",
          price,
          isValid: itemName && !isNaN(price),
        };
      }

      return { isValid: false };
    } catch (e) {
      return { isValid: false };
    }
  }

  document.addEventListener("click", function (e) {
    if (
      e.target.matches(".amp-cart__line-quantity-selector-less") ||
      e.target.closest(".amp-cart__line-quantity-selector-less")
    ) {
      const cartLine = e.target.closest(".amp-cart__cart-line");
      if (cartLine) {
        const quantityInput = cartLine.querySelector(
          ".amp-cart__line-quantity-selector-input"
        );

        if (quantityInput) {
          const currentQuantity = parseInt(quantityInput.value) || 0;

          if (currentQuantity > 1) {
            const itemData = getCartItemData(cartLine);

            if (itemData.isValid) {
              let eventSent = false;

              function sendRemoveEvent(newQty) {
                if (!eventSent && newQty < currentQuantity) {
                  eventSent = true;
                  const removedQuantity = currentQuantity - newQty;

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({ ecommerce: null });
                  window.dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                      currency: STORE_CURRENCY,
                      value: itemData.price * removedQuantity,
                      items: [
                        {
                          item_name: itemData.itemName,
                          item_id: itemData.itemId,
                          price: itemData.price,
                          currency: STORE_CURRENCY,
                          item_brand: "youth&earth",
                          item_category: "Cart Drawer",
                          item_list_name: "cart_drawer",
                          quantity: removedQuantity,
                        },
                      ],
                    },
                  });
                }
              }

              const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                  if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "value"
                  ) {
                    const newQuantity = parseInt(quantityInput.value) || 0;
                    sendRemoveEvent(newQuantity);
                  }
                });
              });

              observer.observe(quantityInput, {
                attributes: true,
                attributeFilter: ["value"],
              });

              let attempts = 0;
              const checkInterval = setInterval(() => {
                attempts++;
                const newQuantity = parseInt(quantityInput.value) || 0;

                sendRemoveEvent(newQuantity);

                if (eventSent || attempts >= 15) {
                  clearInterval(checkInterval);
                  observer.disconnect();
                }
              }, 200);
            }
          }
        }
      }
    }
  });
});

// 3.4 Product page quantity decrease tracking
document.addEventListener("DOMContentLoaded", function () {
  const isProductPage =
    window.location.pathname.includes("/products/") ||
    document.querySelector('[data-section-type="product"]') ||
    document.querySelector(".product-form") ||
    document.querySelector(".product__info") ||
    document.querySelector(".purchase-details__quantity");

  if (!isProductPage) {
    return;
  }

  document.addEventListener("click", function (e) {
    if (
      e.target.matches(".quantity-minus") ||
      e.target.closest(".quantity-minus")
    ) {
      const quantityWrapper = e.target.closest(".quantity-wrapper");
      if (quantityWrapper) {
        const quantityInput = quantityWrapper.querySelector(".quantity-input");

        if (quantityInput) {
          const currentQuantity = parseInt(quantityInput.value) || 0;

          const productTitle =
            document
              .querySelector(".product__title, .product-title")
              ?.textContent?.trim() || "Unknown Product";
          const productSkuElement = document.querySelector(
            '[data-product-id], [data-variant-id], [name="id"]'
          );
          const productSku =
            productSkuElement?.dataset.productId ||
            productSkuElement?.dataset.variantId ||
            productSkuElement?.value ||
            "unknown";
          const priceElement = document.querySelector(
            ".product__price, .price, [data-price], .money"
          );
          const price = priceElement
            ? parseFloat(
                priceElement.textContent
                  .replace(/[^\d.,]/g, "")
                  .replace(/,/g, ".")
              )
            : 0;

          if (currentQuantity > 1) {
            if (productTitle && price > 0) {
              let eventSent = false;

              function sendRemoveEvent(newQty) {
                if (!eventSent && newQty < currentQuantity) {
                  eventSent = true;
                  const removedQuantity = currentQuantity - newQty;

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({ ecommerce: null });
                  window.dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                      currency: STORE_CURRENCY,
                      value: price * removedQuantity,
                      items: [
                        {
                          item_name: productTitle,
                          item_id: productSku,
                          price: price,
                          currency: STORE_CURRENCY,
                          item_brand: "youth&earth",
                          item_category: "Product Page",
                          item_list_name: "product_page",
                          quantity: removedQuantity,
                        },
                      ],
                    },
                  });
                }
              }

              const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                  if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "value"
                  ) {
                    const newQuantity = parseInt(quantityInput.value) || 0;
                    sendRemoveEvent(newQuantity);
                  }
                });
              });

              observer.observe(quantityInput, {
                attributes: true,
                attributeFilter: ["value"],
              });

              let attempts = 0;
              const checkInterval = setInterval(() => {
                attempts++;
                const newQuantity = parseInt(quantityInput.value) || 0;

                sendRemoveEvent(newQuantity);

                if (eventSent || attempts >= 15) {
                  clearInterval(checkInterval);
                  observer.disconnect();
                }
              }, 200);
            }
          }
        }
      }
    }
  });
});
